// "◄ Back · 1 2 · Next ►" pager from the admin redesign. Page-local lists use
// this instead of the shared Pager so the rest of the app is unaffected.
export function PageNav({ offset, limit, total, onChange }: {
  offset: number;
  limit: number;
  total: number | undefined;
  onChange: (offset: number) => void;
}) {
  const totalPages = Math.max(1, Math.ceil((total ?? 0) / limit));
  const page = Math.floor(offset / limit) + 1;
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  const pages: number[] = [];
  for (let p = start; p <= end; p++) pages.push(p);
  const base = "min-w-9 rounded-md border px-2.5 py-1 text-sm disabled:cursor-not-allowed disabled:opacity-40";

  return (
    <div className="flex items-center justify-end gap-1 py-3">
      <button type="button" className={`${base} border-gray-200 text-gray-700 hover:bg-gray-50`} disabled={page <= 1} onClick={() => onChange(Math.max(0, offset - limit))}>
        Back
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          aria-current={p === page ? "page" : undefined}
          className={`${base} ${p === page ? "border-brand bg-brand text-white" : "border-gray-200 text-gray-700 hover:bg-gray-50"}`}
          onClick={() => onChange((p - 1) * limit)}
        >
          {p}
        </button>
      ))}
      <button type="button" className={`${base} border-gray-200 text-gray-700 hover:bg-gray-50`} disabled={page >= totalPages} onClick={() => onChange(offset + limit)}>
        Next
      </button>
    </div>
  );
}
